export * from './components/table/table.component';

export * from './models/table.model';
